import React from 'react';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div id="Loader" />
  );
};

export default Loader;
